import { ConditionRegistryItem } from '../../ConditionRegistryItem';
import { ConditionRegistryCategory } from '../../ConditionRegistryCategory';
export class ConditionRegistryApp extends ConditionRegistryCategory {
    label = 'App';
    constructor(parent) {
        super(parent);
        super.init();
    }
    jiADuz = () => new ConditionRegistryItem({
        /* label: 'isAppEditBuild', */
        eval: ({ app }) => app && app.appInfo.isAppInEditBuild
    });
    SJMTgMwl = () => new ConditionRegistryItem({
        /* label: 'isAppEditing',*/
        eval: ({ app }) => app && app.appInfo.isUserCurrentlyEditing
    });
    HycENfvbx = () => new ConditionRegistryItem({
        /* label: 'isAppRunning', */
        eval: ({ app }) => !app || app.appInfo.isUserCurrentlyRunning
    });
}
